/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PortfolioValueChangedNotificationPayloadDto,
    PortfolioValueChangedNotificationPayloadDtoFromJSON,
    PortfolioValueChangedNotificationPayloadDtoFromJSONTyped,
    PortfolioValueChangedNotificationPayloadDtoToJSON,
} from './PortfolioValueChangedNotificationPayloadDto';

/**
 * 
 * @export
 * @interface PortfolioValueChangedNotificationDto
 */
export interface PortfolioValueChangedNotificationDto {
    /**
     * 
     * @type {string}
     * @memberof PortfolioValueChangedNotificationDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioValueChangedNotificationDto
     */
    portfolioId: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioValueChangedNotificationDto
     */
    portfolioName: string;
    /**
     * 
     * @type {Date}
     * @memberof PortfolioValueChangedNotificationDto
     */
    eventAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof PortfolioValueChangedNotificationDto
     */
    readAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof PortfolioValueChangedNotificationDto
     */
    createdAt: Date;
    /**
     * 
     * @type {string}
     * @memberof PortfolioValueChangedNotificationDto
     */
    type: string;
    /**
     * 
     * @type {PortfolioValueChangedNotificationPayloadDto}
     * @memberof PortfolioValueChangedNotificationDto
     */
    payload: PortfolioValueChangedNotificationPayloadDto;
}

export function PortfolioValueChangedNotificationDtoFromJSON(json: any): PortfolioValueChangedNotificationDto {
    return PortfolioValueChangedNotificationDtoFromJSONTyped(json, false);
}

export function PortfolioValueChangedNotificationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioValueChangedNotificationDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'portfolioId': json['portfolioId'],
        'portfolioName': json['portfolioName'],
        'eventAt': (new Date(json['eventAt'])),
        'readAt': (json['readAt'] === null ? null : new Date(json['readAt'])),
        'createdAt': (new Date(json['createdAt'])),
        'type': json['type'],
        'payload': PortfolioValueChangedNotificationPayloadDtoFromJSON(json['payload']),
    };
}

export function PortfolioValueChangedNotificationDtoToJSON(value?: PortfolioValueChangedNotificationDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'portfolioId': value.portfolioId,
        'portfolioName': value.portfolioName,
        'eventAt': (value.eventAt.toISOString()),
        'readAt': (value.readAt === null ? null : value.readAt.toISOString()),
        'createdAt': (value.createdAt.toISOString()),
        'type': value.type,
        'payload': PortfolioValueChangedNotificationPayloadDtoToJSON(value.payload),
    };
}

